import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import style from './ArticlePanel.module.scss'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import Slider from 'react-slick'
import Tag from '@/features/common/components/Tag'
import { useCustomMediaQuery } from '@/features/common/hooks/useCustomMediaQuery'
import { useCustomRouter } from '@/features/common/hooks/useCustomRouter'
import ArticleModel from '@/features/common/models/articleModel'
import ArticlesModel from '@/features/common/models/articlesModel'
import CustomerService from '@/features/home/components/CustomerService'
import { sendCustomEvent } from '@/utils/GTM'

const settings = {
  slidesPerRow: 1,
  infinite: false,
  swipeToSlide: true,
  speed: 500,
  slidesToShow: 1.3,
  slidesToScroll: 1,
  arrows: false,
}

interface IArticlePanel {
  path: string
  articleModel: ArticleModel
  relatedArticlesModel?: ArticlesModel
}

function ArticlePanel({ path, articleModel, relatedArticlesModel }: IArticlePanel) {
  const { handlePush } = useCustomRouter()
  const { UpToTablet, Mobile } = useCustomMediaQuery()
  const [mounted, setMounted] = useState<boolean>(false)

  const backgroundStyle = {
    backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${articleModel.background})`,
  }

  const handleChangeRoute = (url: string, title: string) => {
    sendCustomEvent({
      event: 'click',
      category: '내부 컨텐츠 보기 클릭',
      label: `연관 인사이트 - ${title}`,
    })
    handlePush(url)
  }

  useEffect(() => {
    setMounted(true)

    return () => setMounted(false)
  }, [])

  if (!mounted) return null

  return (
    <main className={style.container}>
      <div style={backgroundStyle} className={style.container__main}>
        <Tag name={articleModel.tag} />
        <h2 dangerouslySetInnerHTML={{ __html: articleModel.title }} />

        <p>
          <span dangerouslySetInnerHTML={{ __html: articleModel.description }} />
        </p>
        <p>
          <span>{articleModel.date}</span>
        </p>
      </div>
      <ul className={style.container__content}>
        {articleModel.contentList?.map((contentItem, contentIndex) => (
          <li key={contentIndex}>
            {contentItem.image && <Image src={contentItem.image} alt='Image' fill />}
            <div className={style.container__content__item}>
              {contentItem.title && (
                <p
                  className={style.container__content__item__title}
                  dangerouslySetInnerHTML={{ __html: contentItem.title }}
                />
              )}
              <p
                className={style.container__content__item__description}
                dangerouslySetInnerHTML={{ __html: contentItem.description || '' }}
              />
            </div>
          </li>
        ))}
      </ul>
      {relatedArticlesModel && (
        <div className={style.container__section}>
          <div className={style.container__section__article}>
            <h3>연관 인사이트</h3>
            <ul>
              <UpToTablet>
                {relatedArticlesModel?.list?.map(content => (
                  <li key={content.id} onClick={() => handleChangeRoute(`${path}/${content.id}`, content.title)}>
                    <article>
                      <div>
                        <Image src={content.thumbnail} alt={`${content.title} - 이미지`} width={375} height={375} />
                      </div>
                      <p>
                        <span dangerouslySetInnerHTML={{ __html: content.title }} />
                      </p>
                    </article>
                  </li>
                ))}
              </UpToTablet>
              <Mobile>
                <Slider {...settings}>
                  {relatedArticlesModel?.list?.map(content => (
                    <li key={content.id} onClick={() => handleChangeRoute(`${path}/${content.id}`, content.title)}>
                      <article>
                        <div>
                          <Image src={content.thumbnail} alt={`${content.title} - 이미지`} width={375} height={375} />
                        </div>
                        <p>
                          <span dangerouslySetInnerHTML={{ __html: content.title }} />
                        </p>
                      </article>
                    </li>
                  ))}
                </Slider>
              </Mobile>
            </ul>
          </div>
        </div>
      )}

      <CustomerService />
    </main>
  )
}

export default ArticlePanel
